import app from './app'
import auth from './auth'
import env from './env'
import config from './config'
import errors from './errors'
import links from './links'
import {notifications} from './notifications'
import sources from './sources'
import annotations from './annotations'

export default {
  app,
  auth,
  env,
  links,
  config,
  errors,
  sources,
  annotations,
  notifications,
}
